import {default as cart, namespace as cartNamespace} from './modules/cart'
import createPersistedState from 'vuex-persistedstate'
import createMultiTabState from 'vuex-multi-tab-state'

const location = window.addiesaas.location || {}
const locationId = location.id || ''
const locationIdKey = locationId ? `/${locationId}`: ''

const namespaced = true
const namespace = 'Shop/Orders'

const modules = {
  [cartNamespace]: cart
}

// plugins
const plugins = [
  createPersistedState({
    paths: [
      `${namespace}.${cartNamespace}`,
    ],
    key: namespace + locationIdKey,
  }),
  createMultiTabState({
    statesPaths: [
      `${namespace}.${cartNamespace}`,
    ],
    key: 'shop-orders-cart-multi-tab' + locationIdKey,
  })
]

export {namespaced, namespace, plugins, modules}
